import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useSimpleAuth } from '../../context/SimpleAuthContext';
import './SimpleUserPage.css';

const SimpleUserPage = () => {
  const navigate = useNavigate();
  const { user, logout } = useSimpleAuth();

  const handleLogout = () => {
    logout();
    navigate('/simple-login');
  };

  if (!user) {
    return <div>Loading...</div>;
  }

  return (
    <div className="simple-user-container">
      <nav className="simple-nav">
        <h2>Simple User Dashboard</h2>
        <div className="nav-right">
          <span>Welcome, {user.name}!</span>
          <button onClick={handleLogout} className="logout-btn">
            Logout
          </button>
        </div>
      </nav>

      <main className="simple-main">
        <div className="welcome-card">
          <h1>Welcome to Your Dashboard</h1>
          <p>This is a simple demo user page. No complex features, just basic info.</p>
        </div>

        <div className="user-info-card">
          <h3>Your Information</h3>
          <div className="info-grid">
            <div className="info-item">
              <label>Name:</label>
              <span>{user.name}</span>
            </div>
            <div className="info-item">
              <label>Email:</label>
              <span>{user.email}</span>
            </div>
            <div className="info-item">
              <label>Role:</label>
              <span className="role-badge user">{user.role}</span>
            </div>
            <div className="info-item">
              <label>Business Type:</label>
              <span>{user.businessType}</span>
            </div>
          </div>
        </div>

        <div className="features-card">
          <h3>Available Features</h3>
          <div className="features-list">
            <div className="feature-item">
              <span>✅ Chat with AI</span>
              <button onClick={() => navigate('/fullchat')} className="feature-btn">
                Go to Chat
              </button>
            </div>
            <div className="feature-item">
              <span>✅ View Analytics</span>
              <button onClick={() => navigate('/analytics')} className="feature-btn">
                View Analytics
              </button>
            </div>
            <div className="feature-item">
              <span>❌ Profile Settings</span>
              <button className="feature-btn disabled" disabled>
                Coming Soon
              </button>
            </div>
            <div className="feature-item">
              <span>❌ Support</span>
              <button className="feature-btn disabled" disabled>
                Coming Soon
              </button>
            </div>
          </div>
        </div>

        <div className="demo-note">
          <h4>Demo Note</h4>
          <p>This is a simplified demo version. In a real app, you'd have:</p>
          <ul>
            <li>Full chat functionality</li>
            <li>Detailed analytics</li>
            <li>Profile management</li>
            <li>Business insights</li>
          </ul>
        </div>
      </main>
    </div>
  );
};

export default SimpleUserPage;
